import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

export function createBillingQueries(client: StoxlyClient) {
  return createQueryKeys('billing', {
    // ['billing', 'subscription']
    subscription: {
      queryKey: null,
      queryFn: ({ signal }) => client.billingGetSubscription({ signal }),
    },

    // ['billing', 'entitlements']
    entitlements: {
      queryKey: null,
      queryFn: ({ signal }) => client.billingGetEntitlements({ signal }),
    },

    // ['billing', 'plans']
    plans: {
      queryKey: null,
      queryFn: ({ signal }) => client.billingGetPlans({ signal }),
    },

    // ['billing', 'myPlans'] — the plans as THIS user may buy them (launch prices for an Early Bird)
    myPlans: {
      queryKey: null,
      queryFn: ({ signal }) => client.billingGetMyPlans({ signal }),
    },

    // ['billing', 'invoices']
    invoices: {
      queryKey: null,
      queryFn: ({ signal }) => client.billingGetInvoices({ signal }),
    },
  });
}

export function createBillingMutations(client: StoxlyClient) {
  return {
    createCheckout: {
      mutationFn: (body: Body<'billingCreateCheckout'>) => client.billingCreateCheckout(body),
    },
    cancelSubscription: {
      mutationFn: () => client.billingCancelSubscription(undefined),
    },
    resumeSubscription: {
      mutationFn: () => client.billingResumeSubscription(undefined),
    },
    createPortal: {
      mutationFn: (body: Body<'billingCreatePortal'>) => client.billingCreatePortal(body),
    },
  };
}
